import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/custom.scss"

window.Vue = Vue;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js